import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const BookmarkSVG = ({
  stroke = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <path
        d="M12.6666 14L7.99998 11.3333L3.33331 14V3.33333C3.33331 2.97971 3.47379 2.64057 3.72384 2.39052C3.97389 2.14048 4.31302 2 4.66665 2H11.3333C11.6869 2 12.0261 2.14048 12.2761 2.39052C12.5262 2.64057 12.6666 2.97971 12.6666 3.33333V14Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

export default BookmarkSVG;
